import React, {useEffect, useState} from 'react';
import styles from '../css/style.css'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {NavLink} from "react-router-dom";
import {CATEGORY_EVRO_VAGONKA, CATEGORY_PLANED_BOARD} from "../utils/consts";

const MainSlider = () => {
    const [visibleTitle, setVisibleTitle] = useState(false);
    const [visibleText, setVisibleText] = useState(false);
    const [visibleButton, setVisibleButton] = useState(false);

    useEffect(() => {
        setTimeout(() => setVisibleTitle(true), 100); // Задержка перед появлением
        setTimeout(() => setVisibleText(true), 300); // Задержка перед появлением
        setTimeout(() => setVisibleButton(true), 300); // Задержка перед появлением
    }, []);
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000
    };
    return (
        <section className="slider_section mb-40">
            <Slider {...settings}>
                <div className="single_slider1 d-flex align-items-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="slider_content">
                                    <h1 className={`animated-text ${visibleTitle ? "show" : ""}`}>Евровагонка</h1>
                                    <p className={`animated-text ${visibleText ? "show" : ""}`}>Натуральный, экологичный и прочный материал</p>
                                    <NavLink className={`animated-button ${visibleButton ? "show" : ""}`} to={CATEGORY_EVRO_VAGONKA}>Смотреть</NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="single_slider2 d-flex align-items-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="slider_content">
                                    <h1 className={`animated-text ${visibleTitle ? "show" : ""}`}>Строганая доска</h1>
                                    <p>Прочный материал для строительства и ремонта!</p>
                                    <NavLink className="button" to={CATEGORY_PLANED_BOARD}>Смотреть</NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Slider>
        </section>
    );
};

export default MainSlider;